import React from 'react';
import { useContent } from '../cms/content.js';
import AppleWordmark from './AppleWordmark.jsx';

export default function Footer() {
  const cms = useContent();
  return (
    <footer
      style={{
        position: 'relative',
        zIndex: 10,
        background: '#0a0a0b',
        borderTop: '1px solid rgba(201,168,106,0.14)',
        padding: '60px 44px'
      }}
    >
      <div
        style={{
          maxWidth: '1180px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}
      >
        <a
          href="#top"
          className="kny-footer-logo"
          aria-label="KNOW YORKER"
          style={{ textDecoration: 'none' }}
        >
          <AppleWordmark
            appleClassName="kny-footer-logo-apple"
            textClassName="kny-footer-logo-text"
            appleWidth={22}
            appleHeight={25}
          />
        </a>
        <div
          style={{
            font: "500 10px/1.6 'JetBrains Mono',monospace",
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: '#6f6a60',
            textAlign: 'right'
          }}
        >
          {cms.footer.lineTop}
          <br />
          {cms.footer.lineBottom}
        </div>
      </div>
    </footer>
  );
}
